module.exports = __webpack_public_path__ + "img/dataweb.15a73d4b.jpg";